export enum ExchangeApiUrls {
  ExchangeRates = "/v1/ExchangeRates",
}

export enum ExchangeRateTab {
  Cash = "1",
  NonCash = "0"
}
